import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain ,isKsDomain ,isSaficDomain} from 'utils/domain'

import Icon, { IconProps } from './Icon'

/**
 * 時計アイコン
 */
const ClockIcon: React.FC<IconProps> = (props) => {
  const color = isKsDomain() ? 'var(--color-text)' : isSaficDomain() ? 'var(--color-text-for-main-background)' : {
    [DOMAIN.SJ]: 'var(--color-text)',
  }[getDomain()]

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120"
        height="120"
        viewBox="0 0 80 80.8"
      >
        <path
          d="M82,17.4,63.6,1.8l-5.2,6L76.8,23.4ZM25.6,8.2l-5.2-6L2,17.4l5.2,6L25.6,8.2ZM44,26.6H38v24L56.8,62.2,60,57.4,44,47.8Zm-2-16a36,36,0,1,0,36,36A35.85,35.85,0,0,0,42,10.6Zm0,64a28,28,0,1,1,28-28A27.828,27.828,0,0,1,42,74.6Z"
          transform="translate(-2 -1.8)"
          fill={color}
        />
      </svg>
    </Icon>
  )
}

export default ClockIcon
